var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAudioToText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speech--to--text_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11.64,
    width: 12,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 5.64,
    width: 12,
    height: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.359,8.002c0-0.904,0.736-1.64,1.64-1.64h3.146L6.931,8.576L7.44,9.084l2.829-2.828c0.068-0.067,0.105-0.159,0.105-0.254 s-0.038-0.187-0.105-0.254L7.44,2.919L6.931,3.428l2.214,2.214H6c-1.301,0-2.36,1.059-2.36,2.36v4.5h0.72L4.359,8.002L4.359,8.002z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 17.64,
    width: 12,
    height: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,0.64H13c-0.199,0-0.36,0.161-0.36,0.36v13.64H3c-1.301,0-2.36,1.059-2.36,2.36v8c0,1.302,1.059,2.36,2.36,2.36h3.777 l1.901,3.801l0.644-0.322l-2-4C7.261,26.717,7.136,26.64,7,26.64H3c-0.904,0-1.64-0.735-1.64-1.64v-8c0-0.904,0.736-1.64,1.64-1.64 h9.64v4.713C12.267,20.218,12,20.575,12,21s0.267,0.782,0.64,0.927V23c0,0.199,0.161,0.36,0.36,0.36h3.64V25 c0,0.904-0.736,1.64-1.64,1.64H9v0.721h6c1.301,0,2.36-1.059,2.36-2.36v-1.64H31c0.199,0,0.36-0.161,0.36-0.36V1 C31.36,0.801,31.199,0.64,31,0.64z M30.64,22.64H13.36V1.36h17.28V22.64z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 5,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 9,
    cy: 21,
    r: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioToText);
export default __webpack_public_path__ + "static/media/icon-audioToText.f1de38434e9dbf5490e777dff7416852.svg";
export { ForwardRef as ReactComponent };